export const SELECT_INSIGHT = 'INSIGHTS_SELECT_INSIGHT';

export const selectInsightDetails = id => ({
  type: SELECT_INSIGHT,
  id,
});
